export default "__VITE_ASSET__CV1VGv7J__"